"use strict";

exports.__esModule = true;
exports.propTypes = exports.defaultProps = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _input = _interopRequireDefault(require("./input"));

var _textarea = _interopRequireDefault(require("./textarea"));

var _element = _interopRequireDefault(require("../form-ui/element"));

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["forwardedRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  autoComplete: _propTypes.string,

  /** A boolean to represent whether the input field should be disabled */
  bottomLabel: _propTypes.node,

  /** A boolean to represent whether the input field has a status of error */
  disabled: _propTypes.bool,

  /** A boolean to represent whether the input field has a status of success */
  error: _propTypes.bool,

  /** onBlur event handler - used to process the event */
  glyphLeft: _propTypes.node,

  /** onChange event handler - used to process the event */
  glyphRight: _propTypes.node,

  /** onFocus event handler - used to process the event */
  id: _propTypes.string,

  /** Glyph node */
  label: _propTypes.node,

  /** Glyph node */
  onBlur: _propTypes.func,

  /** String for input field id */
  onChange: _propTypes.func,
  onClick: _propTypes.func,

  /** Label for the input field */
  onFocus: _propTypes.func,

  /** Label for the input field */
  pattern: _propTypes.string,

  /** Label for the input field */
  placeholder: _propTypes.string,

  /** Placeholder text to show while input is empty */
  required: _propTypes.bool,

  /** Pattern string to handle validation */
  rows: _propTypes.number,

  /** A boolean to represent whether the input field should be validated */
  success: _propTypes.bool,

  /** A string representing the HTML5 input type */
  topLabel: _propTypes.node,

  /** Value for the text input - managed outside the component */
  type: (0, _propTypes.oneOf)(["text", "email", "password", "tel", "url", "number", "textarea"]),

  /** rows - used when this input field is in textarea mode */
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};
exports.propTypes = propTypes;
var defaultProps = {
  disabled: false,
  error: false,
  success: false,
  type: "text"
};
exports.defaultProps = defaultProps;

var InputComponent = function InputComponent(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var autoComplete = props.autoComplete,
      disabled = props.disabled,
      id = props.id,
      label = props.label,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      pattern = props.pattern,
      placeholder = props.placeholder,
      required = props.required,
      rows = props.rows,
      type = props.type,
      value = props.value;

  var _useFocus = (0, _utils.useFocus)(false, onBlur, onFocus),
      hasFocus = _useFocus[0],
      handleBlur = _useFocus[1],
      handleFocus = _useFocus[2];

  var hasLabel = (0, _react.useMemo)(function () {
    return !!label;
  }, [label]);
  var showValue = (0, _react.useMemo)(function () {
    return !label || hasFocus || !!value;
  }, [hasFocus, label, value]);
  var InputItem = (0, _react.useMemo)(function () {
    return type === "textarea" ? _textarea["default"] : _input["default"];
  }, [type]);

  var _useState = (0, _react.useState)("password"),
      inputType = _useState[0],
      setType = _useState[1];

  var toggleField = (0, _react.useCallback)(function () {
    return inputType === "password" ? setType("text") : setType("password");
  }, [inputType]);
  return /*#__PURE__*/_react["default"].createElement(_element["default"], _extends({
    hasFocus: hasFocus,
    showValue: showValue
  }, props), /*#__PURE__*/_react["default"].createElement(InputItem, {
    autoComplete: autoComplete,
    disabled: disabled,
    fieldId: id,
    onBlur: handleBlur,
    onChange: onChange,
    onClick: onClick,
    onFocus: handleFocus,
    hasLabel: hasLabel,
    pattern: pattern,
    placeholder: placeholder,
    required: required,
    forwardedRef: forwardedRef,
    rows: rows,
    showValue: showValue,
    type: type === "password" ? inputType : type,
    value: value
  }), type === "password" && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    color: "body-grey",
    cursor: "pointer",
    fontSize: 2,
    height: 1,
    onClick: toggleField,
    position: "absolute",
    pr: "8px",
    right: "0px",
    tag: "div"
  }, inputType === "password" ? "show" : "hide"));
};

InputComponent.propTypes = propTypes;
InputComponent.displayName = "Modules.InputComponent";
var _default = InputComponent;
exports["default"] = _default;